<div class="container-fluid">
  <div class="card shadow-lg  bg-body rounded">
    <div class="card-header">
      <h5>{{ title }}</h5>
    </div>
    <div class="card-body checkout">
      <div class="row justify-content:center">
        <div class="col-lg-6 col-sm-12">
          <form [formGroup]="form">
            <div class="row">
              <div class="form-group col-sm-6 ">
                <label for="inputEmail4">Full Name</label>
                <input
                  class="form-control"
                  id=""
                  type="text"
                  placeholder="Full Name"
                  formControlName="name"
                  [ngClass]="{
                    'is-invalid':
                      (isFormSubmitted && form.controls.name.errors) ||
                      (!form.controls.name.pristine &&
                        form.controls.name.invalid)
                  }"
                />
                <div
                  class="invalid-feedback"
                  *ngIf="
                    (isFormSubmitted && form.controls.name.errors) ||
                    (!form.controls.name.pristine && form.controls.name.invalid)
                  "
                >
                  <div *ngIf="form.controls.name.errors.required">
                    <h5 style="color: red">Name is required</h5>
                  </div>
                  <div *ngIf="form.controls.name.errors.pattern">
                    <h5 style="color: red">
                      Only Alphabets with space between 2 to 20 characters
                    </h5>
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-6">
                <label>Email</label>
                <div>
                  <input
                    class="form-control"
                    id=""
                    type="email"
                    placeholder="Email"
                    formControlName="email"
                    [ngClass]="{
                      'is-invalid':
                        (isFormSubmitted && form.controls.email.errors) ||
                        (!form.controls.email.pristine &&
                          form.controls.email.invalid)
                    }"
                  />
                  <div
                    class="invalid-feedback"
                    *ngIf="
                      (isFormSubmitted && form.controls.email.errors) ||
                      (!form.controls.email.pristine &&
                        form.controls.email.invalid)
                    "
                  >
                    <div *ngIf="form.controls.email.errors.required">
                      <h5 style="color: red">Email is required</h5>
                    </div>
                    <div *ngIf="form.controls.email.errors.pattern">
                      <h5 style="color: red">Enter valid emai</h5>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="form-group col-sm-6" *ngIf="user != null">
                <label for="inputEmail4">Password</label>
                <input
                  class="form-control"
                  id="inputPassword3"
                  type="password"
                  placeholder="Password"
                  formControlName="password"
                  [ngClass]="{
                    'is-invalid':
                      (isFormSubmitted && form.controls.password.errors) ||
                      (!form.controls.password.pristine &&
                        form.controls.password.invalid)
                  }"
                />
                <div
                  class="invalid-feedback"
                  *ngIf="
                    (isFormSubmitted && form.controls.password.errors) ||
                    (!form.controls.password.pristine &&
                      form.controls.password.invalid)
                  "
                >
                  <div *ngIf="form.controls.password.errors.required">
                    <h5 style="color: red">Password is required</h5>
                  </div>
                  <div *ngIf="form.controls.password.errors.minlength">
                    <h5 style="color: red">Minimum 8 characters required</h5>
                  </div>
                </div>
              </div> -->
              <div class="form-group col-sm-6">
                <label for="inputEmail5">Address</label>
                <input
                  class="form-control"
                  id="url"
                  type="text"
                  placeholder="Address"
                  formControlName="address"
                  [ngClass]="{
                    'is-invalid':
                      (isFormSubmitted && form.controls.address.errors) ||
                      (!form.controls.address.pristine &&
                        form.controls.address.invalid)
                  }"
                />
                <div
                  class="invalid-feedback"
                  *ngIf="
                    (isFormSubmitted && form.controls.address.errors) ||
                    (!form.controls.address.pristine &&
                      form.controls.address.invalid)
                  "
                >
                  <div *ngIf="form.controls.address.errors.required">
                    <h5 style="color: red">Address is required</h5>
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-6">
                <label for="inputEmail4">Mobile</label>
                <input
                  class="form-control"
                  id="inputnumber"
                  type="number"
                  placeholder="Contact"
                  formControlName="contact_number"
                  [ngClass]="{
                    'is-invalid':
                      (isFormSubmitted &&
                        form.controls.contact_number.errors) ||
                      (!form.controls.contact_number.pristine &&
                        form.controls.contact_number.invalid)
                  }"
                />
                <div
                  class="invalid-feedback"
                  *ngIf="
                    (isFormSubmitted && form.controls.contact_number.errors) ||
                    (!form.controls.contact_number.pristine &&
                      form.controls.contact_number.invalid)
                  "
                >
                  <div *ngIf="form.controls.contact_number.errors.required">
                    <h5 style="color: red">telephone is required</h5>
                  </div>
                  <div *ngIf="form.controls.contact_number.errors.pattern">
                    <h5 style="color: red">enter 10 digit number only</h5>
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-6" *ngIf="hide">
                <label for="inputState">Client</label>
                <select
                  class="form-control digits"
                  id="exampleFormControlSelect9"
                  formControlName="client_id"
                  placeholder="select customer"
                >
                  <option *ngFor="let client of data" value="{{ client.id }}">
                    {{ client.name }}
                  </option>
                </select>
              </div>
              <!-- <div class="form-group col-sm-6" *ngIf="role=='Customer'">
              <label for="inputState">Customer</label>
              <select   class="form-control digits" id="exampleFormControlSelect9"  formControlName="customer_id" placeholder="select customer" >
                <option *ngFor="let customer of data" value="{{customer.id}}">{{customer.name}}</option>
    
            </select>
            </div> -->
              <div class="form-group col-sm-6" *ngIf="role == 'Security'">
                <label for="inputState">Customer</label>
                <select
                  class="form-control digits"
                  name="customer"
                  formControlName="customer_id"
                  placeholder="select customer"
                >
                  <option
                    *ngFor="let customer of data"
                    value="{{ customer.id }}"
                  >
                    {{ customer.name }}
                  </option>
                </select>
              </div>
              <div class="form-group col-sm-6" *ngIf="checkbox">
                <label for="inputEmail5">Reason</label>
                <input
                  class="form-control"
                  id="url"
                  type="text"
                  placeholder="Reason"
                  formControlName="reason"
                  [ngClass]="{
                    'is-invalid':
                      (isFormSubmitted && form.controls.reason.errors) ||
                      (!form.controls.reason.pristine &&
                        form.controls.reason.invalid)
                  }"
                />
                <div
                  class="invalid-feedback"
                  *ngIf="
                    (isFormSubmitted && form.controls.reason.errors) ||
                    (!form.controls.reason.pristine &&
                      form.controls.reason.invalid)
                  "
                >
                  <div *ngIf="form.controls.reason.errors.required">
                    <h5 style="color: red">reason is required</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-6" *ngIf="checkbox">
                <label for="inputState">Date</label>

                <input
                  class="form-control digits"
                  id="appointment_date"
                  type="datetime-local"
                  value=""
                  formControlName="appointment_date"
                />
              </div>

              <div class="form-group col-sm-6" *ngIf="checkbox">
                <label for="inputState">Visitor Type</label>
                <select
                  #mySelect
                  (change)="changeWebsite($event)"
                  class="form-control digits"
                  id="exampleFormControlSelect9"
                  formControlName="visitor_role"
                  placeholder="select visitor type"
                >
                  <option value="cab">Cab</option>
                  <option value="delviery">Delviery</option>
                  <option value="guest">Guest</option>
                  <option value="parcles">Parcles</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div class="form-group col-sm-6" *ngIf="checkbox">
                <div *ngIf="checkboxhide">
                  <label for="inputState"></label>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      id="gridCheck"
                      value="true"
                      type="checkbox"
                      formControlName="entry_status"
                    />
                    <label class="form-check-label" for="gridCheck"
                      >Leave at the gate</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="card-footer" style="padding-left: 50px">
            <button
              class="btn btn-primary"
              type="button"
              style="width: 110px; height: 30px"
              (click)="onSubmit()"
              placement="top"
              ngbTooltip="submit"
            >
              Submit</button
            >&nbsp;
            <button
              class="btn btn-warning"
              type="button"
              placement="top"
              style="width: 100px; height: 30px"
              ngbTooltip="reset"
              (click)="onCancel()"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
